import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {useCopyToClipboard} from 'common/hooks/useCopyToClipboard';
import {getBnSettupUrl} from 'utils/div';
import {Divider, IconButton, Layout, Text} from '@phonectas/unifon-ui-kit';
import NewCopyIcon from 'common/components/icons/NewCopyIcon';
import DefaultFilterSelect from './components/DefaultFilterSelect';

interface ThreeSixtySettingsProps {
  feedFilter: string[];
  onChange?: (val: string | string[]) => void;
  // Only users who can save settings get the filter (see canUseUserConfig)
  showFeedFilter: boolean;
}

const ThreeSixtySettings: React.FC<ThreeSixtySettingsProps> = ({feedFilter, onChange, showFeedFilter}) => {
	const [t] = useTranslation();
	const url = getBnSettupUrl();
	const [copyToClipboard] = useCopyToClipboard();
	const handleFilterChange = useCallback(
		(val: string | string[]) => {
			if (onChange) {
				onChange(val);
			}
		},
		[onChange]
	);
	const handleCopyUrl = useCallback(() => {
		copyToClipboard(url);
	}, [url, copyToClipboard]);

	return (
		<Layout fullWidth nowrap direction="column">
			<Layout direction="column" gap="xs" alignItems="start">
				<Text variant="h1">{t('Unifon 360')}</Text>
				<Text variant="h3" color="textSecondary">
					{t('User settings')}:
				</Text>
			</Layout>
			<Layout nowrap direction="column" gap="xs" alignItems="start">
				<Text variant="body1" color="textSecondary">
					{t('BN external URL routing')}
				</Text>
				<Layout fullWidth nowrap alignItems="center" gap="xs">
					<Text variant="body1">{url}</Text>
					<IconButton onClick={handleCopyUrl} size="xxs">
						<NewCopyIcon />
					</IconButton>
				</Layout>
			</Layout>
			{
				showFeedFilter && (
					<>
						<Divider />
						<Layout direction="row" gap="sm" nowrap autoOverflow alignItems="center" fullWidth>
							<Layout
								alignItems="start"
								direction="column"
								gap="md"
								nowrap
								style={{width: '250px'}}
							>
								<Text variant="h3" color="textSecondary">{t('Event log filter')}:</Text>
								<DefaultFilterSelect
									value={feedFilter}
									onChange={handleFilterChange}
									t={t}
								/>
							</Layout>
						</Layout>
					</>
				)
			}
			{/* <Divider /> */}
		</Layout>
	);
};

export default ThreeSixtySettings;